import { useEffect, useState } from "react";
import Table from "../../../../components/Table";

function ReceiptsTable({
  objects,
  onSort,
  schema,
  selected,
  onCollapse,
  onEdit,
  onConfirmAudit,
  isAdmin,
  ...props
}) {
  const actions = [
    {
      label: "Edit",
      icon: "bi bi-pencil",
      className: "btn btn-primary text-white btn-sm fw-medium",
      onClick: (object) => {
        onEdit(object);
        console.warn("object", object);
      },
    },
    {
      label: "Confirm Audit",
      icon: "bi bi-check2",
      show: (object) => {
        return isAdmin && object?.status === "for_audit";
      },
      className: "btn btn-success text-white btn-sm fw-medium",
      onClick: (object) => {
        onConfirmAudit(object);
      },
    },
  ];

  return (
    <>
      <div className="d-flex flex-column">
        <Table
          fields={schema.fields}
          //   onClick={this.clickData.bind(this)}
          onCollapse={onCollapse}
          collapsable
          objects={objects}
          excludeFields={Object.keys(schema.fields).reduce(
            (acc, key) => {
              const options = schema.fields[key];
              if (options.read === false || options._read === false) {
                acc.push(key);
              }
              switch (options._type || options.type) {
                case "Relation":
                case "Array":
                case "Object":
                case "File":
                  acc.push(key);
                  break;
                default:
              }
              return acc;
            },
            ["acl", "id", "created", "updated"],
          )}
          selected={selected}
          //   onSelectAll={this.onSelectAll.bind(this)}
          //   progress={progress}
          //   onClickItem={this.onClickItem.bind(this)}
          onEdit={onEdit}
          actions={isAdmin ? actions : []}
          onSort={onSort}
          className="mt-1"
          {...props}
        />
      </div>
    </>
  );
}

export default ReceiptsTable;
